<template>
  <!-- Phase 2 - US-013: Fee Management Page -->
  <div class="p-3">
    <h4 class="mb-3">Fee Management</h4>
    <b-tabs content-class="mt-3" v-model="activeTab">
      <b-tab title="Fee Master" active>
        <fee-master></fee-master>
      </b-tab>
      <b-tab title="Fee Waivers" v-if="isAdmin">
        <fee-waiver></fee-waiver>
      </b-tab>
      <b-tab title="Fee Report" v-if="isAdmin">
        <fee-report></fee-report>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import FeeMaster from "../components/fee/FeeMaster.vue";
import FeeWaiver from "../components/fee/FeeWaiver.vue";
import FeeReport from "../components/fee/FeeReport.vue";

export default {
  name: "FeeManagement",
  components: {
    FeeMaster,
    FeeWaiver,
    FeeReport,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>
